import gql from 'graphql-tag';

export class UniversalLinkMutations {
  static identifyRecipient = gql`
    mutation IdentifyRecipient($gdprConsent: Boolean, $documentId: String!, $email: String!) {
      identifyRecipient(gdprConsent: $gdprConsent, documentId: $documentId, email: $email) {
        url
      }
    }
  `;
}
